import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useShoppingListStore = defineStore('shoppingListStore', () => {
  const shoppingList = ref({})
  const addressUpdated = ref(false)

  return {
    shoppingList,
    addressUpdated
  }
})
